module.exports = __webpack_public_path__ + "static/media/approved.3ac323a0.svg";